<!--
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version: 
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-31 19:07:05
 * @Descripttion: 
 -->
<template>
    <div class="city">
        <v-head :isShowBack="$route.meta.isShowIcon" >选择城市</v-head>
        
        <div class="flex-btwn-aic mt  city-loc" @click="chooseCity('loc')">
          <div class="flex-aic">
            <div>{{locCity}}</div>
            <span class="el-icon-location city-loc-bg"></span>
            <span class="color-999">当前所在城市</span>
          </div>
          <div class="color-blue" @click.stop="refrashLoc"><span class="el-icon-refresh"></span> 刷新位置</div>
        </div>

        <div class="city-list" v-if="cityList && cityList.length > 0">
          <div class="city-info-item" v-for="(item, index) in cityList" :key="index">
            <div class="city-item-title">{{item.name}}</div>
            <div class="city-item" v-for="(i, index) in item.list" :key="index" @click="chooseCity(i)">{{i.name}}</div>
          </div>
            <!-- <mt-index-list>
                <mt-index-section index="">
                    <div class="city-hot-list">
                        <div class="city-hot-title">热门城市</div>
                        <div class="flex-wrap">
                            <div class="city-hot-item">徐州市</div>
                            <div class="city-hot-item">连云港市</div>
                            <div class="city-hot-item">南京市</div>
                            <div class="city-hot-item">苏州市</div>
                            <div class="city-hot-item">上海市</div>
                            <div class="city-hot-item">西安市</div>
                            <div class="city-hot-item">杭州市</div>
                            <div class="city-hot-item">常州市</div>
                        </div>
                    </div>
                </mt-index-section>
                <mt-index-section index="A">
                    <div class="city-item" v-for="(item, index) in 10" :key="index">Aaron</div>
                    <div class="city-item">Alden</div>
                    <div class="city-item">Austin</div>
                </mt-index-section>
                <mt-index-section index="B">
                    <div class="city-item" v-for="(item, index) in 10" :key="index">Braden</div>
                    <div class="city-item">Baldwin</div>
                    <div class="city-item">Braden</div>
                </mt-index-section>
                <mt-index-section index="C">
                    <div class="city-item" v-for="(item, index) in 10" :key="index">Craden</div>
                    <div class="city-item">Caldwin</div>
                    <div class="city-item">Craden</div>
                </mt-index-section>
                <mt-index-section index="D">
                    <div class="city-item" v-for="(item, index) in 10" :key="index">Draden</div>
                    <div class="city-item">Daldwin</div>
                    <div class="city-item">Draden</div>
                </mt-index-section>
                <mt-index-section index="E">
                    <div class="city-item" v-for="(item, index) in 10" :key="index">Eraden</div>
                    <div class="city-item">Ealdwin</div>
                    <div class="city-item">Eraden</div>
                </mt-index-section>
                <mt-index-section index="F">
                    <div class="city-item" v-for="(item, index) in 10" :key="index">Fraden</div>
                    <div class="city-item">Faldwin</div>
                    <div class="city-item">Fraden</div>
                </mt-index-section>
            </mt-index-list> -->
        </div>

        <div v-else class="no-data">暂无更多数据</div>

        

        


    </div>
</template>
<script>

import { GetPost } from '@/api/point.js'
import { GetLoc } from "@/assets/js/utils.js";
import vHead from "@/components/vHead.vue";
export default {
    components: {
        vHead
    },

    data() {
        return {
           cityList:[],
           locCity:'定位中...'
        };
    },
    mounted() {
      let _ = this
      document.body.style.backgroundColor = '#F4F5F7'

      if(sessionStorage.city && sessionStorage.city != 'null' && sessionStorage.city != 'undefined'){
        _.locCity = sessionStorage.city
      }else{
        GetLoc(()=>{
          console.log('哈哈')
          _.locCity = sessionStorage.city
        })
        
      }
    },
    created(){
      let _ = this
      _.getCityList()
    },
    methods:{
      refrashLoc(){
        let _ = this
        GetLoc(()=>{
          console.log('哈哈')
          _.locCity = sessionStorage.city
        })
      },
        getCityList(){
          let _ = this
          let pars = {
            url:'http://csp.schengle.com/csp-web-website/webArea/getSourceShopAreaList',
            params: { sourceCode:"NHSXETC" }
          }
          GetPost(pars).then(res=>{
            var data = JSON.parse(res.result).shopSiteAreaTreeVO
            let _proObj = new Object();
            let _allCityDate = new Object();
            for (var j = 0, len = data.length; j < len; j++) {
              if (data[j]['type'] == '0') {
                var _id = data[j]['id'];
                _proObj[_id] = new Object();
                _proObj[_id].name = data[j]['name'];
                _proObj[_id].list = new Array();
              }
            }
            for (var j = 0, len = data.length; j < len; j++) {
              if (data[j]['type'] == '1') {
                var _pid = data[j]['pId'];
                if (_proObj.hasOwnProperty(_pid)) {
                  var _list = _proObj[_pid].list;
                  _list.push(data[j]);
                }
              }
            }
            var cityList = []
            for(var key in _proObj){
                var cityObj = {}
                cityObj = _proObj[key]
                cityList.push(cityObj)
            }
            _.cityList = cityList
            console.log(' _.cityList', _.cityList)
          }).catch(err=>{
            if(err&&err.resultDesc){
              _.toast(err.resultDesc)
            }
          })
        },
        chooseCity(i){
          let _ = this
          console.log('获取到的参数',i)
          if( i == 'loc' ){
            sessionStorage.cityName = sessionStorage.city
          }else{
            sessionStorage.cityName = i.name
          }
          
          _.$router.push('/shop/list')
        }
    }
}
</script>
<style lang="scss" scoped>

.city{
  // background-color: #fff;
  @mixin cityItem{
    width: 100%;
    height: 12vw;
    line-height: 12vw;
    background-color: #fff;
    border-bottom: 1px solid #EDEDED;
    padding: 0 4vw;
  }
  .city-tip{
    padding: 4.8vw 4vw;
    color: #FF8864;
    font-size: 3.2vw;
    background-color: #F4F5F7;
  }
  .city-loc{
    @include cityItem;
    font-size: 4vw;
    .city-loc-bg{
      display: block;
      margin: 0 2vw;
    }
    .city-loc-tip{
      font-size: 3.2vw
    }
  }
  .city-list{
    .city-hot-list{
      padding: 4vw;
      .city-hot-title{
        font-size: 3.2vw;
        color: #C7C7C7;
      }
      .city-hot-item{
        padding: 0 4.6667vw;
        line-height: 7vw;
        height: 7vw;
        border-radius: 0.8vw;
        background-color: #F6F5F5;
        font-size: 3.2vw;
        margin: 3.7333vw 5.3333vw 0 0;
      }
    }
    .city-item-title{
      width: 100%;
      height: 12vw;
      line-height: 12vw;
      background-color: #F4F5F7;
      padding: 0 4vw;
    }
    .city-item{
      @include cityItem;
      font-size: 3.7333vw;
    }
  }
}

</style>


